module.exports = __webpack_public_path__ + "static/media/muralIcons.e900a122.svg";